import Axios, { AxiosError } from 'axios';
import store from '@/vuex/store';
import { vueInstance } from './main';
import ToastrHelper from './toastr-helper';

export function initInterceptor() {
  // Outgoing request interceptor
  Axios.interceptors.request.use(
    function(config) {
      const token = (store.state as any).authorization.accessToken;
      
      if (token && !config.url?.includes('/Buddy/Response')) {
        config.headers = {
          Authorization: `Bearer ${token}`
        };
      }

      return config;
    },
    function(error) {
      return Promise.reject(error);
    }
  );

  // Response interceptor
  Axios.interceptors.response.use(
    function(response) {
      return response.data;
    },
    function(error: AxiosError) {
      if (!error?.response?.status) return false;

      if (error.response.status === 401 || error.response.status === 403) {
        vueInstance.router.push({ name: '403' });
      }

      if (error.response.status >= 500) {
        vueInstance.router.push({ name: '500' });
      }

      if (error.response.status === 400) {
        if (error.response?.data?.error && error.response?.data?.error[0].message) {
          ToastrHelper.errorToastr(error.response.data.error[0].message);
        } else {
          ToastrHelper.errorToastr('Er is iets fout gegaan. Als deze melding blijft voorkomen, neem dan contact op met de administrator.');
        }
      }

      return Promise.reject(error.response);
    }
  );
}
